export default "__VITE_ASSET__DMHgG$18__"